import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  kicker,
  title,
  subtitle,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-61" data-mp="3f2n73y24osr0">
      {kicker && <p className={`mb-3 font-display text-sm font-bold uppercase tracking-[0.14em] ${dark ? 'text-aqua' : 'text-navy-700'}`} data-id="element-62" data-mp="3k187bxhdrcfg">
          {kicker}
        </p>}
      <h2 className={`font-display text-[2rem] font-black leading-[1.08] tracking-tight sm:text-5xl [text-wrap:balance] ${dark ? 'text-white' : 'text-ink'}`} data-id="element-63" data-mp="gj6u18t599hw">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? 'text-white/75' : 'text-ink/70'}`} data-id="element-64" data-mp="6sc5tywc7ztt">{subtitle}</p>}
    </div>;
}